import React from 'react';
import { Flex, FormLabel, Textarea, Stack } from '@chakra-ui/react';
import { scrollBarStyle } from '../../utils/layoutConfig';
import _ from 'lodash';
import { useCallback } from 'react';
import { updateComponent } from '../../redux/pagesSlice';
import { selectComponent, selectedComponent } from '../../redux/selectedComponentSlice';
import { selectedPage } from '../../redux/selectedPageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { findCompByIdRecursively } from '../../utils/functions';

const EditorTextarea = ({ propName, title, values, componentId, arrayIndex, originalPropname }) => {
	const [options, setOptions] = React.useState({ title, values });
	const selectedPageValue = useSelector(selectedPage);
	const selectedComponentValue = useSelector(selectedComponent);
	const dispatch = useDispatch();
	const debounceFn = useCallback(_.debounce(handlePagesUpdate, 300), [
		selectedPageValue,
		componentId,
		selectedComponentValue,
	]);

	function handlePagesUpdate(value) {
		const newSelectedComponent = _.cloneDeep(selectedComponentValue);
		const { comp } = findCompByIdRecursively([newSelectedComponent?.props], componentId);

		if (typeof comp.props[propName] === 'object') {
			comp.props[propName][title] = value;
		} else if (originalPropname) {
			if (typeof comp.props[originalPropname][arrayIndex][propName] === 'object') {
				comp.props[originalPropname][arrayIndex][propName][title] = value;
			} else {
				comp.props[originalPropname][arrayIndex][propName] = value;
			}
		} else {
			comp.props[propName] = value;
		}
		dispatch(
			updateComponent({
				component: comp,
				componentId,
				pageId: selectedPageValue,
			}),
		);

		if (newSelectedComponent?.childComp) {
			const { comp: originalComp } = findCompByIdRecursively([newSelectedComponent?.props], componentId);
			originalComp.props = _.cloneDeep(comp.props);
		}
		//precisa disso pro componente renderizar corretamente se alterar + de 1 prop
		dispatch(selectComponent(newSelectedComponent));
	}

	function handleChange(e) {
		const value = e.target.value;
		const newOptions = JSON.parse(JSON.stringify(options));
		newOptions.values[0].value = value;
		setOptions(newOptions);
		debounceFn(value);
	}

	//arrumar para a aparecer o handler de aumentar tamanho ao colocar a scrollbarstyle
	return (
		<Flex className="mz-hef-edit" flex={'1 1 100%'} maxW={'100%'} flexDir="column">
			<label
				className="mz-hef-edit-label"
				mr={0}
				borderColor={'gray.200'}
				fontFamily={'Poppins'}
				color={'gray.700'}
				fontWeight="bold"
				fontSize={'sm'}
			>
				{options.title}
			</label>
			<Stack spacing={1}>
				{options.values.map((el, i) => {
					return (
						<textarea
							h={'120px'}
							sx={scrollBarStyle}
							onChange={(e) => {
								handleChange(e, i);
							}}
							key={i}
							value={el.value}
							focusBorderColor={'yellow.400'}
							size={'sm'}
							borderRadius={8}
							placeholder={el.placeholder}
						></textarea>
					);
				})}
			</Stack>
		</Flex>
	);
};

export default EditorTextarea;
